/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// fix Cartier shopping cart issue

document.addEventListener("DOMContentLoaded", function (event) {

  document.querySelectorAll('[href="/collections/cartier"]').forEach((el) => {
    $(el).unbind('click');
    el.addEventListener('click', function (e) {
      window.location.href = "/collections/cartier";
      e.stopPropagation();
      return false;
    });
  });
});


// GIF Creator



async function createGIF() {
  const loadImage = async (img) => {
    return new Promise((resolve, reject) => {
      img.onload = async () => {
        resolve(true);
      };
    });
  };

  const height = 720;
  const width = 600;

  const encoder = new GIFEncoder();
  console.log(encoder)
  encoder.setRepeat(0); //0  -> loop forever, 1+ -> loop n times then stop
  encoder.setDelay(1000); //go to next frame every n milliseconds
  encoder.setSize(width, height);
  encoder.start();

  const productImages = document.querySelectorAll('.Product__SlideItem--image.Carousel__Cell img');

  productImages.forEach(async (imageEl) => {
    console.log(imageEl)
    imageEl.src = imageEl.dataset.originalSrc;
    await loadImage(imageEl);
    console.log(imageEl.src);
    fetch(imageEl.src, { method: "HEAD" }).then((response) => console.log(response.headers.get("Content-type")));
    console.log(imageEl)

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    context.fillStyle = "white";
    context.fillRect(0, 0, canvas.width, canvas.height);
    // context.imageSmoothingQuality = "high";

    const logoEl = document.querySelector('.Header__LogoImage--primary');
    context.drawImage(logoEl, (canvas.width / 2) - 184, 50, 368, 65);
    context.drawImage(imageEl, 50, 160, 500, 500);
    console.log(imageEl)

    console.log(context);
    console.log(canvas);
    // context.translate(0.5, 0.5);

    // context.color = 'black';
    // context.font = "normal 22px Nunito Sans";
    // // context.rotate(-);
    // context.fontStyle = 'normal';
    // context.letterSpacing = '0.2em';
    // context.textAlign = 'center';
    // context.textBaseline = 'middle';
    // context.fillStyle = 'black';
    // context.fillText("ESTATE WATCH & JEWELRY CO.", (canvas.width / 2), 80);
    // context.textTransform = 'uppercase';
    encoder.addFrame(context);

  });


  setTimeout(() => {
    encoder.finish();
    // console.log(encode64(encoder.stream().getData()));
    encoder.download("jewelry.gif");
  }, 1500);
}


document.addEventListener("DOMContentLoaded", function (event) {

  if (document.querySelector('.ProductMeta__Description')) {
    const downloadShare = document.createElement('a');
    downloadShare.classList.add('ProductMeta__ShareTitle');
    downloadShare.classList.add('Heading');
    downloadShare.classList.add('Text--subdued');
    downloadShare.classList.add('u-h7');
    downloadShare.style.cursor = 'pointer';
    downloadShare.style.display = 'block';

    downloadShare.innerHTML = 'Photos';
    downloadShare.addEventListener('click', createGIF);
    
    // Try to append to the download photos container first, fallback to original location
    const downloadContainer = document.querySelector('#download-photos-container');
    if (downloadContainer) {
      downloadContainer.appendChild(downloadShare);
    } else {
      // Fallback to original location if combined section is not shown
      downloadShare.style.marginTop = '5px';
      document.querySelector('.Product__Info > .Container').appendChild(downloadShare);
    }
  }

  const phone = document.querySelectorAll('[rel="phone"]');
  phone.forEach(function (el) {
    el.addEventListener("click", (e) => {
      fbq("track", "Call");
    });
  });

  var maxMilliseconds = 60 * 1000; // make sure the visitor doesn't receive a reply within 60 seconds
  var replyTimer = null;

});
